import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import {useParams} from 'react-router-dom';
import { useLocalStorage, useDebounce } from 'react-use';
import useNotif from 'hooks/use-notify-hook';
import {Button, Card, Col, Form, Row } from 'react-bootstrap';
import FileUpload from 'components/FileUpload/FileUpload.js';
import AnswerRepository from 'repository/Answer.js';

function Formula ({ answer, isReadonly, formulas, setFormulas }) {

  const {employeeId} = useParams();
  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [input, setInput] = useState(answer.ANSWER_DESC || '');
  const [attachments, setAttachments] = useState(answer?.answerAttachments || []);
  const [sqlResult, setSqlResult] = useState(null);
  const repository = new AnswerRepository(auth.token);

  const handleUpload = async (file) => {

    try{

      const response = await repository.upload(answer.ANSWER_ID, file);

      dispatchNotif({
        place: `br`,
        message: `Upload Success...`,
        type: `success`,
      });

      // setAttachments([...attachments,response.data]);
      attachments.push(response.data);

    }catch(ex){

      dispatchNotif({
        place: `br`,
        message: `Upload Failed ${ex.toString()}`,
        type: `danger`,
      });

    }
  }

  const handleDeleteAttachment = async(attachmentId) => {

    try{

      const response = await repository.deleteAttachment(attachmentId);

      dispatchNotif({
        place: `br`,
        message: `Delete Success...`,
        type: `success`,
      });

      var data =  attachments.filter(attachment => attachment.ATTACHMENT_ID != attachmentId);

      setAttachments(data);

    }catch(ex){

      dispatchNotif({
        place: `br`,
        message: `Failed ${ex.toString()}`,
        type: `danger`,
      });

    }
  }


  const calculateSql = async () => {

    const response = await axios.post(
      `${process.env.REACT_APP_API_HOST}questions/execute`,
      {SQL_TEXT: answer.question.SQL_TEXT},
      {headers: {Authorization: `Bearer ${auth.token}`}},
    );

    setSqlResult(response.data);

  }


  const [, cancelInput] = useDebounce(async () => {


    window.formula[answer.question.QUESTION_ID] = input;
    const formulaScoreId = eval(answer.question.FORMULA);
    const payload = {
      ANSWER_AT: moment().format('YYYY-MM-DD hh:mm:ss'),
      ANSWER_BY: employeeId,
      ANSWER_DESC: input,
      INDEX_ID: formulaScoreId,
    };

    const response = await repository.answer(answer.ANSWER_ID, payload, auth.token);

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

  }, 2000, [input]);



  useEffect(() => {

    if (!answer.ANSWER_DESC && answer.question.SQL_TEXT) {
      calculateSql();
    }

    cancelInput();
  }, []);


  useEffect(() => {

    if (sqlResult) {
      setInput(sqlResult);
    }

  }, [sqlResult]);


  useEffect(() => {

    if (input) {

      window.formula[answer.question.QUESTION_ID] = input;
      const formulaScoreId = eval(answer.question.FORMULA);

      setFormulas([...formulas, {
        ANSWER_DESC: sqlResult,
        INDEX_ID: formulaScoreId,
        ANSWER_ID: answer.ANSWER_ID,
      }]);
    }
  }, [input]);

  return (
    <Row>
      {notif}
      <Col md="12">
        <Card>
          <Card.Header>
            <Card.Title as="h4"><a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="10">
                <Form.Group>
                  <Row>
                    {answer.question.SQL_TEXT
                      ? (
                          <Col md="2">
                            <Form.Label>Answer:</Form.Label>
                            <p>{input}</p>
                          </Col>
                        )
                      : (
                        <Col md="2">
                          <Form.Label>Answer:</Form.Label>
                          <Form.Control
                            value={input}
                            onChange={({target: {value}}) => setInput(value)}
                            type="number"
                            style={{textAlign: 'end'}}
                            placeholder={0}
                            disabled={isReadonly}
                          />
                        </Col>
                      )
                    }
                  </Row>
                </Form.Group>
              </Col>
              <Col md="2">
                <FileUpload
                  onFileSelectSuccess={(file) => handleUpload(file)}
                  onFileSelectError={({ error }) => alert(error)}
                  disabled={isReadonly}
                >
                  Upload
                </FileUpload>{` `}
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <Form.Group>
                  {attachments
                    ? attachments.map((attachment, key) => (
                        <div key={key} className="font-icon-detail">
                          <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`}>
                            {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                          </a>
                          {' '}
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDeleteAttachment(attachment.ATTACHMENT_ID)}
                          >
                            <i className="nc-icon nc-simple-remove"></i>
                          </Button>
                        </div>
                      ))
                    : (<p>No file uploaded.</p>)
                  }

                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default React.memo(Formula, (prev, next) => {
  if (prev.answer.ANSWER_DESC === next.answer.ANSWER_DESC) return true;
});